import { Plus } from "lucide-react";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import { track } from "@/lib/posthog";

interface KanbanNewStatusColumnProps {
  onCreate: () => void;
}

/**
 * The board's last column: a button that opens the New status dialog.
 *
 * A new status is placed at the end of the board (`nextSortOrder`), so its
 * column appears exactly where this one was clicked, and this one moves right.
 */
export function KanbanNewStatusColumn({ onCreate }: KanbanNewStatusColumnProps) {
  const { t } = useLanguage();
  // Sized like a column's "+ Add Issue" and sitting on the header row, so it
  // reads as a column waiting to be named rather than an empty one. `-mt-1`
  // centres it on the header row, which is a few pixels shorter.
  return (
    <button
      type="button"
      onClick={() => {
        onCreate();
        track("issue_status_creation_opened", { surface: "kanban" });
      }}
      className="-mt-1 flex w-72 shrink-0 items-center justify-center gap-1 self-start rounded-lg border border-dashed border-border px-3 py-2 text-xs text-muted-foreground transition-colors hover:border-primary/40 hover:text-primary/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <Plus className="h-3.5 w-3.5" />
      {t.pm.issues.statuses.newStatus}
    </button>
  );
}
